import React from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { scrollTo } from "../utils/scrollTo";
import CoverPNG from "./../assets/img/cover_2.png";
import LogoPNG from "./../assets/img/logo.png";
import { transitionMixin } from "./../components/mixins";

const CoverContainer = styled.div`
    position: relative;
    max-height: 750px;
    width: 70%;
    margin: 0 auto;

    ${({ show }) => (show ? "" : "display:none;")}

    .cover-container {
        position: relative;
        top: -320px;
        z-index: 0;
        width: 100%;
        overflow: hidden;
    }

    img.cover {
        width: 100%;
        object-fit: contain;
        ${transitionMixin("1s")};

        &:hover {
            transform: scale(1.05);
        }
    }

    @media screen and (max-width: 1250px) {
        max-height: 750px;
        width: 90%;
    }

    @media screen and (max-width: 1050px) {
        max-height: 650px;
        width: 100%;

        .cover-container {
            top: -200px;
        }
    }

    @media screen and (max-width: 830px) {
        width: 100%;

        .cover-container {
            position: relative;
            display: block;
            top: unset;
            left: unset;
            width: 100%;
            max-width: 400px;
            margin: 0 auto;
        }
    }
`;

const MHRightStyles = css`
    left: unset;
    right: 30px;

    @media screen and (max-width: 830px) {
        bottom: 5%;
        right: 10px;
        width: auto;
    }

    @media screen and (max-width: 500px) {
        bottom: 5%;
        left: unset;
        right: 10px;
        width: auto;
    }
`;

const MagazineHeader = styled.div`
    position: absolute;
    display: inline-flex;
    align-self: flex-start;
    flex-direction: column;
    align-items: flex-start;
    bottom: 12%;
    max-width: 70%;
    padding: 0 0 8px;
    margin: 0 20px;
    left: 15px;
    transform: translateY(0%);
    overflow: hidden;
    color: ${({ theme }) => theme.colors.white};

    &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        width: 100%;
        transform: translateX(-100%);
        background-color: ${({ theme }) => theme.colors.white};
        ${transitionMixin()};
    }

    &:hover::before {
        transform: translateX(0%);
    }

    @media screen and (max-width: 830px) {
        bottom: 0;
        width: 80%;
    }

    @media screen and (max-width: 500px) {
        left: 0;
        bottom: 0;
        width: auto;
    }

    ${({ variant }) => (variant === "right" ? MHRightStyles : "")}
`;

const SubTitle = styled.h6`
    text-transform: ${({ uppercase }) => (uppercase ? "uppercase" : "none")};
    color: ${({ color }) => (color ? color : "")};
    display: inline-block;

    ${({ variant }) =>
        variant === "right"
            ? css`
                  align-self: flex-end;
              `
            : ""}

    @media screen and (max-width: 560px) {
        font-size: ${({ theme }) => theme.fz.XXXS};
    }
`;

const Description = styled.h1`
    text-transform: ${({ uppercase }) => (uppercase ? "uppercase" : "none")};
    display: inline-block;
    font-size: 4.8rem;
    line-height: 120%;

    @media screen and (max-width: 830px) {
        font-size: ${({ theme }) => theme.fz.XXL};
    }

    @media screen and (max-width: 560px) {
        font-size: ${({ theme }) => theme.fz.XL};
    }
`;

const LogoRightStyles = css`
    left: unset;
    right: 0;
    transform: translate(-10%, -160%);

    @media screen and (max-width: 1050px) {
        max-width: 300px;
        transform: translate(-10%, -100%);
    }

    @media screen and (max-width: 830px) {
        max-width: 200px;
        left: 50%;
        transform: translate(-10%, 50%);
    }

    @media screen and (max-width: 400px) {
        left: 50%;
        transform: translate(-20%, 50%);
    }
`;

const Logo = styled.img`
    position: absolute;
    top: -20px;
    left: 0;
    transform: translate(10%, -160%);
    max-width: 350px;

    @media screen and (max-width: 1050px) {
        max-width: 300px;
        transform: translate(10%, -100%);
    }

    @media screen and (max-width: 830px) {
        max-width: 200px;
        left: 50%;
        transform: translate(-80%, 50%);
    }

    @media screen and (max-width: 340px) {
        left: 50%;
        transform: translate(-70%, 50%);
    }

    ${({ variant }) => (variant === "right" ? LogoRightStyles : "")}
`;

const HeaderComponent = ({ shouldShow }) => (
    <CoverContainer show={shouldShow}>
        <div className="cover-container">
            <picture>
                <img className="cover" src={CoverPNG} alt="Okładka magazynu" />
            </picture>

            <MagazineHeader variant="right">
                <SubTitle uppercase color="#000" variant="right">
                    SPOSOBY NA ZDROWIE
                </SubTitle>
                <Description>
                    Odporności
                    <br />
                    jesienią
                    <br />
                    nigdy dość!
                </Description>
            </MagazineHeader>
        </div>

        <Link to="/" onClick={scrollTo(0, 0)}>
            <Logo variant="right" src={LogoPNG} />
        </Link>
    </CoverContainer>
);
export default HeaderComponent;
